var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotocopienb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-linecap:round;stroke-width:2px;}.cls-1,.cls-3{stroke:#e6007e;stroke-miterlimit:10;}.cls-2,.cls-3{fill:#e6007e;}.cls-3{stroke-width:0.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "impression_nb",
    "data-name": "impression nb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.14,23.34h-6.2V20.58h6.2a.68.68,0,0,0,.69-.68.69.69,0,0,0-.69-.69h-6.2V15.76a.69.69,0,0,0-.69-.69H35.91V12.31H27.64v2.76h-9a.69.69,0,0,0-.69.69V26.5l-4.67-4.67a.69.69,0,0,0-1,1L18,28.45v6.32L13.32,30.1a.69.69,0,0,0-1,1L18,36.72V53a.68.68,0,0,0,.69.68H53.14a.68.68,0,0,0,.69-.68V24A.69.69,0,0,0,53.14,23.34ZM29,13.69h5.51v1.38H29V13.69Zm-4.14,38.6H19.37V16.45h5.51Zm20.68,0H26.26v-6.9h19.3Zm0-8.27H26.26v-6.9h19.3Zm0-8.27H26.26v-6.9h19.3Zm0-8.27H26.26V22h19.3Zm0-6.9H26.26V19.21h19.3Zm0-2.75H26.26V16.45h19.3Zm6.89,34.46H46.94V24.72h5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.53,22.65H27.64v4.14h6.89Zm-1.38,2.76H29V24h4.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 35.91,
    y: 22.65,
    width: 1.38,
    height: 1.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 35.91,
    y: 24.72,
    width: 1.38,
    height: 1.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.98,
    y: 22.65,
    width: 1.38,
    height: 1.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.98,
    y: 24.72,
    width: 1.38,
    height: 1.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 40.04,
    y: 22.65,
    width: 1.38,
    height: 1.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 40.04,
    y: 24.72,
    width: 1.38,
    height: 1.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.11,
    y: 22.65,
    width: 1.38,
    height: 1.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.11,
    y: 24.72,
    width: 1.38,
    height: 1.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.15,30.92h5.52a.69.69,0,0,0,0-1.38H33.15a.69.69,0,0,0,0,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.15,39.19h5.52a.69.69,0,0,0,0-1.38H33.15a.69.69,0,0,0,0,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.15,47.46h5.52a.69.69,0,0,0,0-1.38H33.15a.69.69,0,0,0,0,1.38Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotocopienb);
export default __webpack_public_path__ + "static/media/photocopienb.3cb4cdf1214ca7f1f5a36f276c4d1d58.svg";
export { ForwardRef as ReactComponent };